import React, { Fragment, useEffect, useState } from 'react'
import Button from '../../Buttons/Button';
import AccordionMain from '../AccordionRow/AccordionMain';
import AddSystemPopUp from '../PopUps/AddSystem/AddSystemPopUp';
import { POP_UPS_TRANSLATION } from '../../../../constants/translations/customer/PopUps/PopUps';
import DeletePopUp from '../PopUps/Delete/DeletePopUp';
import '../FileTab/FileTab.scss'
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { systemActionsCreator } from '../../../../actions/customer/systemActions';
import TabEmptyLanding from '../../MobileViews/TabEmptyLanding/TabEmptyLanding';
import EmptyList from '../EmptyList/EmptyList';
import "./SystemTab.scss";
import { systemTabDesktopBtn, systemTabPopUpBtn } from "./SystemTabStatic";
import AddExcelFilePopUp from '../../PopUps/AddExcelFilePopUp/AddExcelFilePopUp';

export default function SystemTab(props) {
    const { view, process, closePopup, componentFor, customer } = props;
    const [currentPopup, setCurrentPopup] = useState('add');
    const [showPopUp, setShowPopUp] = useState(false);
    const [showExcelPopUp, setShowExcelPopUp] = useState(false);
    const [systemId, setSystemId] = useState(null);
    const [parentSystemId, setParentSystemId] = useState(null);
    let orderId = process && process.order_id;
    const [currentLayer, setCurrentLayer] = useState(1);
    const [addSystemActionLevel, setAddSystemLevel] = useState(1);

    const dispatch = useDispatch();
    const accordionDataTree = useSelector((state) => state.customerSystems.systemsForAccordion);
    const selectedSystem = useSelector((state) => state.customerSystems.singleSystem);
    const isShowSystemsPopup = useSelector((state) => state.customerSystems.isShowSystemsPopup);

    function handleShowPopUp() {
        setShowPopUp(!showPopUp)
    }

    function handleShowExcelPopUp() {
        setShowExcelPopUp(!showExcelPopUp)
    }

    function onClickHandler(label) {
        setShowPopUp(true);
    }

    const popupClickHandlers = {
        'Add System': (systemID, layer) => {
            setCurrentLayer(layer +  1);
            setAddSystemLevel(layer + 1);
            setParentSystemId(systemID)
            setCurrentPopup('add');
            handleShowPopUp();
        },
        'Edit System': (systemId, layer) => {
            setCurrentPopup('edit');
            setCurrentLayer(layer)
            setSystemId(systemId);
            dispatch(systemActionsCreator.selectedSystemBySystemId({ systemId, layer }));
            handleShowPopUp();
        },
        'Delete System': (systemId, layer) => {
            setCurrentPopup('delete');
            setCurrentLayer(layer);
            setSystemId(systemId);
            handleShowPopUp();
            if (systemId && layer) {
                dispatch(systemActionsCreator.selectedSystemBySystemId({ systemId, layer }))
            }
        },
        'Move Up': (index, layer) => {
            if(index>0){
                dispatch(systemActionsCreator.moveSystemRow({ index, layer,  direction: 'up' }))
            }else{
                alert("can't move up")
            }
        },
        'Move Down': (index, layer) => {
            dispatch(systemActionsCreator.moveSystemRow({ index, layer,  direction: 'down' }))
        },
    }

    useEffect(() => {
        if (!customer) {
            dispatch(systemActionsCreator.getSystemsByOrderId(orderId));
        }        
    }, [dispatch, orderId])

    useEffect(() => {
        if (customer) {
            dispatch(systemActionsCreator.getSystemsByCustomer(customer));
        } 
    }, []);


    const updateSystems = () => {
        if (customer) {
            dispatch(systemActionsCreator.getSystemsByCustomer(customer));
        } 
    }

    const updateFilesList = (attachments) => {
        // Handle systems imported from Excel
        if (attachments && attachments.length) {
            updateSystems();
        }
    }

     useEffect(()=>{
         setShowPopUp(isShowSystemsPopup)
     }, [isShowSystemsPopup])

    const systemNameToDelete = selectedSystem.system_name;
    const locationDescriptionToDelete = selectedSystem.location_description;
    const floorToDelete = selectedSystem.location_floor;
    const widthToDelete = selectedSystem.width;
    const heightToDelete = selectedSystem.height;

    const deleteInfoPopUp = {
        title: POP_UPS_TRANSLATION.DELETE_SYSTEM,
        subtitle: POP_UPS_TRANSLATION.DELETE_SYSTEM_CONFIRMATION,
        parentSystemId: selectedSystem.parent_system_id,
        info: [
            { label: POP_UPS_TRANSLATION.SYSTEM_NAME, value: systemNameToDelete &&( typeof (systemNameToDelete) === 'object' ? systemNameToDelete.name : systemNameToDelete) },
            { label: POP_UPS_TRANSLATION.LOCATION_DESCRIPTION, value: locationDescriptionToDelete && locationDescriptionToDelete },
            { label: POP_UPS_TRANSLATION.FLOOR, value: floorToDelete && floorToDelete },
            { label: POP_UPS_TRANSLATION.WIDTH, value: widthToDelete && widthToDelete },
            { label: POP_UPS_TRANSLATION.HEIGHT, value: heightToDelete && heightToDelete },
        ]
    }
    return (
        <div className='system__container'>
            <div className={componentFor === 'add-order' ? 'systems__list--addOrder' : 'systems__list'}>
                {
                    accordionDataTree.length ? accordionDataTree.map((accordionData, index) => {
                        return <Fragment key={index}>
                            <AccordionMain
                                data={accordionData.data}
                                systemId={accordionData.id}
                                view={props.view}
                                onClickHandler={onClickHandler}
                                popupClickHandlers={popupClickHandlers}
                                rowIndex={index}
                                process={process}
                            />
                        </Fragment>
                    }) : view !== 'mobile' ? <EmptyList name={'system'} /> : <TabEmptyLanding title={'system'} />
                }
        </div>
            <div className={showPopUp ? 'popUp__background' : ""}>
                {
                    showPopUp ?
                        <>
                            <div style={{ visibility: currentPopup && currentPopup === 'delete' ? 'visible' : 'hidden' }}>
                                <DeletePopUp
                                    showPopUp={showPopUp}
                                    handleShowPopUp={handleShowPopUp}
                                    data={deleteInfoPopUp}
                                    view={view === 'desktop-popup' ? 'desktop' : view}
                                    id={systemId}
                                    layer={currentLayer}
                                    popUpFor={'system'}
                                />
                            </div>
                            <div style={{ visibility: currentPopup && currentPopup === 'edit' ? 'visible' : 'hidden' }}>
                                <AddSystemPopUp
                                    showPopUp={showPopUp}
                                    handleShowPopUp={handleShowPopUp}
                                    name={POP_UPS_TRANSLATION.EDIT_SYSTEM}
                                    view={view}
                                    mode={'edit'}
                                    setParentSystemId={setParentSystemId}
                                    from="e"
                                    customerId={customer._id}
                                    updateSystems={updateSystems}
                                />
                            </div>
                            <div style={{ visibility: currentPopup && currentPopup === 'add' ? 'visible' : 'hidden' }}>
                                <AddSystemPopUp
                                    showPopUp={showPopUp}
                                    handleShowPopUp={handleShowPopUp}
                                    name={POP_UPS_TRANSLATION.ADD_A_SYSTEM}
                                    layer={currentLayer}
                                    addSystemActionLevel={addSystemActionLevel}
                                    view={view}
                                    parentSystemId={parentSystemId}
                                    setParentSystemId={setParentSystemId}
                                    customerId={customer._id}
                                />
                            </div>
                        </> : null
                }
            </div>

            {/* Excel Upload Popup */}
            <AddExcelFilePopUp 
                showPopUp={showExcelPopUp}
                handleShowPopUp={handleShowExcelPopUp}
                name="Upload Excel File"
                view={view === 'desktop-popup' ? 'desktop' : view}
                customerId={customer?._id}
                customerName={customer?.name}
                updateFilesList={updateFilesList}
                mode="add"
            />

            {
                props.view === 'desktop-popup' ? 
                <Grid item xs={12} className='fileTab__btnRow'>
                    <Grid item xs={6} className='fileTab__btnRow-right'>
                        <Button data={systemTabPopUpBtn.save} />
                        &nbsp;
                        &nbsp;
                            <Button data={systemTabPopUpBtn.cancel} handleClick={() => closePopup()} />
                    </Grid>

                        <Grid item xs={6} className='fileTab__btnRow-left'>
                            <Button
                                data={systemTabPopUpBtn.addSystem}
                                handleClick={() => {
                                    setCurrentPopup('add');
                                    handleShowPopUp()
                                }}
                            />
                            {
                                componentFor === 'add-order' ?
                                    <>
                                        &nbsp;
                                        &nbsp;
                                        <Button data={systemTabDesktopBtn.uploadExcel} handleClick={handleShowExcelPopUp} />
                                    </> : null
                            }
                        </Grid>
                </Grid> 
                : <Grid item xs={12} className='fileTab__btnRow--desktop'>
                        <Button data={systemTabDesktopBtn.uploadExcel} handleClick={handleShowExcelPopUp} />
                    &nbsp;
                    &nbsp;
                        <Button
                            data={systemTabDesktopBtn.addSystem}
                            handleClick={() => {
                                setCurrentPopup('add');
                                handleShowPopUp()
                                setCurrentLayer(1);
                            }}
                        />
                </Grid>
            }
        </div>
    )
}